// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24CUL","toggle":"styles_toggle__3KUMT","preview":"styles_preview__d8aID"};